(ns quuppa.qsm.api-docs.component
  (:require [quuppa.components :as components]
            [shadow.lazy :as lazy]))

(def api-docs-view (lazy/loadable quuppa.qsm.apidocs/view))

(defn lazy-api-docs
  "Loads Swagger API docs view lazily using shadow.lazy.
  Displays 'Loading view' text until component is loaded."
  [opts]
  [components/lazy-component
   ;; TODO: Spinner
   {:fallback [:div.p-3.d-flex.justify-content-center
               [:h5 "Loading view..."]]}
   api-docs-view
   opts])
